import type { PluginOptions } from 'gatsby-plugin-react-i18next/dist/types';

export default {
    localeJsonSourceName: 'locale',
    languages: [ 'en', 'de' ],
    defaultLanguage: 'zz',
    generateDefaultLanguagePage: true,
    i18nextOptions: {
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    },
    redirect: true,
    fallbackLanguage: 'en',
    /*pages: [
     {
     matchPath: '/:lang?/result/:uid',
     getLanguageFromPath: true,
     },
     ],*/
} as PluginOptions;
